<template>
  <section class="vehicles-index">
    <vehicles-list-filter />

    <search-bar
      v-model="searching"
      :placeholder="searchPlaceholder"
      class="vehicles-list-search"
      @input="searchVehicles"
    />

    <vehicles-list-filters
      v-if="filtering"
      class="vehicles-list-filters"
      @change="filterVehicles"
    />

    <ul ref="scroller">
      <vehicles-list
        key="vehicles-list"
        :items="items"
        :vehicles="vehicleModels"
        :actions="actions"
      />
    </ul>
  </section>
</template>

<script>
  import { mapState } from 'vuex';

  import monetize from '@sdk/helpers/formatters/monetize';

  import { findFilters, findQueryParams } from '@/views/Settings/Commercial/Form/helpers';

  import { INITIAL_VEHICLE_FILTERS } from '@/store/modules/vehicle-models';

  import VehiclesListFilter from '@/views/Settings/Vehicles/List/Filter.vue';
  import VehiclesListFilters from '@/views/Settings/Vehicles/List/Filters.vue';

  import SearchBar from '@/components/Search/Bar.vue';

  import VehiclesList from '@/views/Settings/Vehicles/List.vue';

  export default {
    name: 'VehiclesIndex',
    components: {
      VehiclesListFilter,
      VehiclesListFilters,
      SearchBar,
      VehiclesList,
    },
    data() {
      return {
        items: [{
          id: 'situation',
          label: 'Situação',
          field: 'active',
          formatter: value => (value ? 'Ativo' : 'Inativo'),
        }, {
          id: 'fuel',
          label: 'Combustível',
          field: 'fuel',
          formatter: value => (value ? value.name : null),
        }, {
          id: 'yearStart',
          label: 'Ano modelo inicial',
          field: 'year_start',
        }, {
          id: 'yearEnd',
          label: 'Ano modelo final',
          field: 'year_end',
        }, {
          id: 'price',
          label: 'Preço público sugerido',
          field: 'public_price_cents',
          formatter: value => (value ? monetize(value) : null),
        }],
        actions: {
          update: 'settings-vehicles-update',
        },

        searching: '',
        searchingTimeout: null,
        searchPlaceholder: 'Pesquisar pelo nome do veículo, Molicar ou Fipe',
        limit: false,
        count: 0,
      };
    },
    computed: {
      ...mapState([
        'vehicleModels',
      ]),

      filtering() {
        return this.vehicleModels.list.filters.show;
      },
    },
    mounted() {
      this.initialFilter();
      window.addEventListener('scroll', this.scrollVehicles, { passive: true });
    },
    beforeDestroy() {
      this.clearVehicles();
      window.removeEventListener('scroll', this.scrollVehicles, { passive: true });
    },
    methods: {
      initialFilter() {
        let foundFilters = {};
        const { page, ...queryParameters } = this.$route.query;

        foundFilters = findFilters(queryParameters, INITIAL_VEHICLE_FILTERS);

        if (page) {
          foundFilters.page = 1; // parseInt(page, 10);
        }

        this.fetchVehicles(foundFilters);
      },

      searchVehicles(value) {
        const MOLICAR_FIPE_PATTERN = /\d+-?\d*/g;
        clearTimeout(this.searchingTimeout);

        const params = {
          page: 1,
          name_molicar_fipe: '',
          q: '',
          CRUDL_append: false,
        };

       if (MOLICAR_FIPE_PATTERN.test(value)) {
         params.name_molicar_fipe = value;
       } else {
         params.q = value;
       }

        this.searchingTimeout = setTimeout(this.fetchVehicles, 500, params);
      },

      clearVehicles() {
        this.$store.dispatch('vehicleModels/clear', { action: 'list' });
      },

      filterVehicles(params) {
        this.clearVehicles();

        this.fetchVehicles({
          ...params,
          page: 1,
        });
      },

      fetchVehicles(params) {
        this.$store
          .dispatch('vehicleModels/filter', params)
          .then(this.getVehicles);
      },

      getVehicles() {
        const {
          filters,
          items,
        } = this.vehicleModels.list;

        this.updateQuery();
        this.count = Object.keys(items).length;

        this.$store
          .dispatch('vehicleModels/list', filters)
          .then(this.gotVehicles);
      },

      gotVehicles() {
        const {
          items,
        } = this.vehicleModels.list;

        const count = Object.keys(items).length;

        if (this.count === count) {
          this.limit = true;
        } else {
          this.count = count;
        }
      },

      updateQuery() {
        if (this.$route.name !== 'settings-vehicles') {
          return;
        }

        const {
          per_page: perPage,
          show,
          CRUDL_append: crudl,
          q,
          name_molicar_fipe: nameMolicarFipe,
          ...filters
        } = this.vehicleModels.list.filters;

        let query = {};
        query = findQueryParams(filters);

        this.$router.replace({
          name: 'settings-vehicles',
          query,
        });
      },

      scrollVehicles() {
        const {
          scroller,
        } = this.$refs;

        if (this.limit || this.vehicleModels.list.loading || !scroller) {
          return;
        }

        const top = (
          document.scrollingElement
          || document.documentElement
          || document.body
          || {}
        ).scrollTop;

        if (top && window.innerHeight + top >= scroller.$el.offsetHeight) {
          this.paginateVehicles();
        }
      },

      paginateVehicles() {
        const {
          page,
        } = this.vehicleModels.list.filters;

        this.fetchVehicles({
          page: page + 1,
          CRUDL_append: true,
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '@/assets/stylesheets/_variables.scss';

  .vehicles-list-search {
    margin: 0 var(--product--pwa--horizontal);

    @media all and (min-width: $breakpoint-desktop) {
      margin: 0 var(--product--pwa--horizontal) $gutter-small;
    }
  }
</style>
